module.exports = __webpack_public_path__ + "media/images/patient-icons/edit-icon-b4bc36e00836bf223b7d23a517d824c5.svg";